
import { inject } from '@angular/core';
import {Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivateFn} from '@angular/router';
import { Observable } from 'rxjs';
import {SignUpService} from "../service/sign-up.service";

export const registrationGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
    const signUpService = inject(SignUpService);
    const router = inject(Router);

  if (!signUpService.registrationGuid && !signUpService.phoneNumber) {
    router.navigate(['/sign-up']); // Redirect to login page
    return false;
    } else {
    return true;
    }
};
